// Helper: slideToggle/slideDown/slideUp sem jQuery (preserva comportamento de .slideToggle)
function slideDown(el, duration) {
  duration = duration || 300;
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  const height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = '0px';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  void el.offsetHeight;
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

function slideUp(el, duration) {
  duration = duration || 300;
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.boxSizing = 'border-box';
  el.style.height = el.offsetHeight + 'px';
  void el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = '0px';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  setTimeout(() => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(el, duration) {
  if (window.getComputedStyle(el).display === 'none') {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
}

// fetchProductData: usado por main.js (btn-cart-garantia) e quick-add.js
window.fetchProductData = function(target) {
  const handle = target.getAttribute('product-id');
  const variant = target.getAttribute('variant');
  let url = `/products/${handle}?section_id=garantia-produto`;
  if (variant) url = `/products/${handle}?variant=${variant}&section_id=garantia-produto`;

  target.classList.add('waiting');

  fetch(url, { method: 'GET' })
    .then(r => r.text())
    .then(response => {
      try {
        const jsonMatch = response.match(/{[\s\S]*}/);
        if (jsonMatch) {
          const data = JSON.parse(jsonMatch[0]);
          if (!data.error) {
            console.log(data);
            target.classList.remove('waiting');
            openModalGarantia(data);
          } else {
            console.error("Erro: Produto não encontrado.");
          }
        } else {
          console.error("Erro: JSON não encontrado na resposta.");
        }
        target.classList.remove('waiting');
      } catch (e) {
        console.error("Erro ao processar JSON:", e);
        target.classList.remove('waiting');
      }
    })
    .catch(() => {
      console.error("Erro ao buscar os dados do produto.");
    });
};

function openModalGarantia(data) {
  if (!data) return;

  const container = document.querySelector('.garantia-container');
  const itemsBox = document.querySelector('.garantia-items');
  const addBtn = document.querySelector('.add-cart-garantia');
  const checkoutBtn = document.querySelector('.cart__checkout-button');

  if (container) container.classList.add('active');
  if (itemsBox) itemsBox.innerHTML = '';
  if (addBtn) addBtn.setAttribute('data-id', data.id);

  data.garantias.forEach((item, index) => {
    const isFirst = index === 0;
    if (isFirst && checkoutBtn) checkoutBtn.setAttribute('data-garantia', item.id);
    const garantiaHtml = `
      <div class="item ${isFirst ? 'selected' : ''}" data-id="${item.id}">
        <p class="name">${item.title}</p>
        <p class="price">${item.price}</p>
      </div>
    `;
    if (itemsBox) itemsBox.insertAdjacentHTML('beforeend', garantiaHtml);
  });

  document.querySelectorAll('.garantia-items .item').forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelectorAll('.garantia-items .item').forEach(i => i.classList.remove('selected'));
      this.classList.add('selected');
      const btn = document.querySelector('.cart__checkout-button');
      if (btn) btn.setAttribute('data-garantia', this.getAttribute('data-id'));
    });
  });

  document.querySelectorAll('.add-cart-garantia').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      addProdutoGarantia(this);
    });
  });
}

function addProdutoGarantia(target) {
  const produto = parseInt(target.getAttribute('data-id'), 10);
  const garantia = parseInt(target.getAttribute('data-garantia'), 10);
  const originalText = target.textContent;
  const items = [];

  if (produto) items.push({ id: produto, quantity: 1 });
  if (!isNaN(garantia) && garantia > 0) items.push({ id: garantia, quantity: 1 });

  if (items.length === 0) {
    console.error("Nenhum item válido para adicionar ao carrinho.");
    return;
  }

  target.textContent = 'Adicionando ao Carrinho...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(r => r.json())
    .then(response => {
      console.log("Produtos adicionados com sucesso!", response);
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error("Erro ao adicionar produtos:", error);
      target.textContent = originalText;
    });
}

window.initSliderProduto = function() {
  const swiperOptions = {
    spaceBetween: 10,
    navigation: { nextEl: '.proximo5', prevEl: '.anterior5' },
    pagination: { el: '.swiper-pagination', clickable: true },
  };

  if (window.innerWidth > 768) {
    const swiperThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 20,
      slidesPerView: 6,
      freeMode: true,
      watchSlidesProgress: true,
    });
    swiperOptions.thumbs = { swiper: swiperThumbs };
  }
  new Swiper('.gallery-main', swiperOptions);
};

function initSliderThumbnails() {
  document.querySelectorAll('slider-component').forEach(sliderWrapper => {
    const slider = sliderWrapper.querySelector('ul');
    const progressBar = sliderWrapper.querySelector('.slider-progress__bar');
    if (!slider || !progressBar) return;

    function updateProgress() {
      const scrollLeft = slider.scrollLeft;
      const scrollWidth = slider.scrollWidth;
      const clientWidth = slider.offsetWidth;
      const maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        return;
      }
      const percentage = (scrollLeft / maxScroll) * 100;
      progressBar.style.width = percentage + '%';
    }

    slider.addEventListener('scroll', updateProgress);
    updateProgress();
  });
}

function verificarProdutosAtivos() {
  let qtdAtivos = 0;
  let total = 0;

  document.querySelectorAll('.item-comprar').forEach(item => {
    const produto = item.querySelector('.assign-produto.active');
    if (produto) {
      qtdAtivos++;
      const precoBr = produto.getAttribute('data-price');
      if (precoBr) {
        const precoNormalizado = parseFloat(precoBr.replace(/\./g, '').replace(',', '.'));
        if (!isNaN(precoNormalizado)) total += precoNormalizado;
      }
    }
  });

  const btn = document.querySelector('.btn-comprar-junto');
  if (!btn) return;

  btn.classList.toggle('active', qtdAtivos > 0);
  const qtdEl = btn.querySelector('.qtd');
  if (qtdEl) qtdEl.textContent = qtdAtivos;

  const totalFormatado = total.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  const priceEl = btn.querySelector('.price-num');
  if (priceEl) priceEl.textContent = totalFormatado;
}

initSliderThumbnails();

function isMobile() {
  return window.innerWidth <= 750;
}

function smoothScrollTo(top, duration) {
  duration = duration || 600;
  const start = window.scrollY;
  const change = top - start;
  const startTime = performance.now();
  function easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
  function step(now) {
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / duration, 1);
    window.scrollTo(0, start + change * easeInOutQuad(progress));
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', function() {
  const mobile = isMobile();

  // Footer accordion mobile movido pra menu.js (carrega em todas as paginas, nao so PDP)

  document.querySelectorAll('.btn-cart-garantia').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      window.fetchProductData(this);
    });
  });

  // .btn-topo movido pra menu.js (carrega em todas as paginas, nao so PDP)

  // .drawer-filter-mobile .filter-toggle movido pra menu.js (eh da collection page, nao da PDP)

  document.querySelectorAll('.garantia-container .return-drawer, .garantia-container .drawer__close, #garantia-overlay').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      const container = document.querySelector('.garantia-container');
      if (container) container.classList.remove('active');
    });
  });

  document.querySelectorAll('.product-pay-info .info-toggle').forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const content = this.parentElement.querySelector('.info-content');
      if (content) slideToggle(content);
    });
  });

  document.querySelectorAll('.assign-produto').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      this.classList.toggle('active');
      verificarProdutosAtivos();
    });
  });

  document.querySelectorAll('.btn-comprar-junto').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      const itensParaAdicionar = [];

      document.querySelectorAll('.item-comprar button').forEach(itemBtn => {
        const item = itemBtn.closest('.item-comprar');
        if (!item) return;
        const formElement = item.querySelector('.assign-produto');
        if (formElement && formElement.classList.contains('active')) {
          const productId = formElement.dataset.product;
          itensParaAdicionar.push({ id: productId, quantity: 1 });
        }
      });

      if (itensParaAdicionar.length === 0) {
        console.log('Nenhum produto ativo para adicionar.');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itensParaAdicionar })
      })
        .then(r => r.json())
        .then(data => {
          console.log('Produtos adicionados:', data);
          document.querySelectorAll('.btn-cart-garantia, .product-form__buttons button').forEach(el => el.click());
        });
    });
  });

  // Codigo de menu desktop (hover categorias, megamenu, submenu) movido pra assets/menu.js
  // porque main.js so carrega em template product (Iter 8) e o menu precisa funcionar em todas as paginas.

  // Sticky-buy mobile
  if (mobile) {
    const infoContainer = document.querySelector('.product__info-container');
    if (infoContainer) {
      window.addEventListener('scroll', function() {
        const rect = infoContainer.getBoundingClientRect();
        const infoTop = rect.top + window.scrollY + infoContainer.offsetHeight;
        const scrollTop = window.scrollY;
        const stickyBuy = document.querySelector('.sticky-buy');
        if (!stickyBuy) return;
        if (scrollTop > infoTop) stickyBuy.classList.add('active');
        else stickyBuy.classList.remove('active');
      });
    }
  }

  document.querySelectorAll('.desc-mais').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      const content = this.parentElement.querySelector('.content');
      if (content) content.classList.toggle('active');
    });
  });

  // Botão afiliado
  document.querySelectorAll('#afiliado-link').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      const originalText = this.textContent;
      const link = this.getAttribute('data-link');
      this.textContent = 'Copiado!';
      setTimeout(() => { this.textContent = originalText; }, 2000);
      navigator.clipboard.writeText(link)
        .then(() => console.log('link copiado!'))
        .catch(err => console.error('Erro ao copiar:', err));
    });
  });

  document.querySelectorAll('.search-tab-list li').forEach(li => {
    li.addEventListener('click', function(e) {
      e.preventDefault();
      const target = this.getAttribute('data-target');
      document.querySelectorAll('.search-tab, .search-tab-list li').forEach(x => x.classList.remove('active'));
      console.log(target);
      this.classList.add('active');
      const tab = document.querySelector(`.search-tab[data-target="${target}"]`);
      if (tab) tab.classList.add('active');
    });
  });
});
